import React, {useState, useEffect} from "react";
import { GetMarketingPromotionByIdData} from "../../../lib/data";
import { useParams } from "react-router-dom";
import i18n from "../../../lib/i18n";
import { devices, marketingPromotionPosition } from "../../../lib/definitions";
import EditMarketingPromotionsUi from "../../../ui/marketingPromotionsUi/editMarketingPromotionsUi";

export default function EditMarketingpromotions () {

    const [marketingPromotionsData, setMarketingPromotionsData] = useState({});
    const {marketingPromotionId} = useParams();
    const t = i18n.t.bind(i18n); 
    
    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const marketingPromotionData = await GetMarketingPromotionByIdData(marketingPromotionId);
        setMarketingPromotionsData([]);
        setMarketingPromotionsData(marketingPromotionData.data);
    };

    return(
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.marketing")}</h1>
                <EditMarketingPromotionsUi marketingPromotionsData={marketingPromotionsData} devices={devices} marketingPromotionPosition={marketingPromotionPosition}/>
            </div>
        </div>
    );
};